import styled from "styled-components";

export interface ITooltipArrowBoxProps {
    borderColor?: string;
}

export const TooltipArrowDefaultBox = styled.div<ITooltipArrowBoxProps>`
    &, &:before {
      position: absolute;
      width: 12px;
      height: 12px;
      background: inherit;
    }

    visibility: hidden;
    
    &:before {
      visibility: visible;
      content: '';     
      transform: rotate(45deg);
      border-top: 1px solid ${({borderColor, theme}) => borderColor ? borderColor : theme.colors.boxBorderContrast};
      border-left: 1px solid ${({borderColor, theme}) => borderColor ? borderColor : theme.colors.boxBorderContrast};
    }
`;